<template>
  <div class="py-2">
    <div v-if="warningSection">
      <div class="h1 d-flex justify-center">Are you sure?</div>
      <div class="d-flex justify-center text-center mt-7">
        With great power comes great <br />
        responsibility.
      </div>
      <div class="d-flex justify-center text-center my-9">
        Emails will go to every User on your filtered list regardless of their
        communication preferences. Reserve this option for essential
        communications.
      </div>
      <div class="d-flex justify-space-between mx-5">
        <v-btn outlined depressed text class="px-14" @click="close"
          >Cancel</v-btn
        >
        <v-btn depressed color="primary" class="px-14" @click="WriteEmailBtn"
          >Write Email</v-btn
        >
      </div>
    </div>
    <!-----------Write email------------------------->
    <div v-if="writeEmailSection">
      <div class="h2">Compose and Send Email</div>
      <div class="my-4 d-flex">
        <b>Email Subject:</b>
        <v-text-field
          outlined
          dense
          v-model="email.EmailSubject"
          class="ml-5"
          hide-details
          height="10"
        ></v-text-field>
      </div>
      <div class="mt-2"><b>Email Body</b></div>
      <vue-editor v-model="email.content" :editor-toolbar="customToolbar" />
      <div class="my-4">
        This email will be sent to <b> {{ this.GetUsers.length }}</b> Users.
      </div>
      <div class="d-flex">
        <b>Email Attachments: </b>

        <input type="file" @change="onFileChange" multiple class="ml-5" />
      </div>
      <div class="d-flex justify-space-between mx-5 mt-9">
        <v-btn outlined depressed text class="px-14" @click="close"
          >Cancel</v-btn
        >
        <v-btn depressed color="primary" class="px-14" @click="previewEmailbtn"
          >Preview Email</v-btn
        >
      </div>
    </div>
    <!----------- email preview------------------------->
    <div v-if="emailPreviewSection">
      <div class="d-flex justify-center">
        <NewBodyTalkLogo />
      </div>
      <div class="mt-7"><b>Subject:</b>{{ email.EmailSubject }}</div>
      <div class="my-8">{{ email.content }}</div>
      <div>
        <b>Attachments:</b> <br />
        <div v-for="(items, i) in email.files" :key="i">
          {{ items.name }}
        </div>
      </div>
      <div class="my-4" style="color: #24b663">
        This email will be sent to <b> {{ this.GetUsers.length }}</b> Users.
      </div>
      <div class="d-flex justify-space-between mx-5 mt-9">
        <v-btn outlined depressed text class="px-14" @click="GoBack"
          >Back</v-btn
        >
        <v-btn
          depressed
          color="primary"
          class="px-14"
          @click="SendEmailBtn"
          :disabled="btnloader"
        >
          <span v-if="btnloader != true">Send Email</span>
          <v-progress-circular
            indeterminate
            size="20"
            v-else
            class="px-5"
            color="white"
            v-show="btnloader"
          ></v-progress-circular
        ></v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { mapGetters } from "vuex";
import NewBodyTalkLogo from "../../../assets/SvgIcons/NewBodyTalkLogo.vue";

export default {
  name: "SendBulkEmailComponent",
  props: ["bulkemail"],
  components: { VueEditor, NewBodyTalkLogo },
  data() {
    return {
      // loading: false,
      btnloader: false,
      email: {
        EmailSubject: "",
        content: "<h1>Html For Editor</h1>",
        files: [],
      },
      emailPreviewSection: false,
      warningSection: true,
      writeEmailSection: false,

      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      ],
    };
  },
  computed: {
    ...mapGetters(["GetUsers"]),
  },
  methods: {
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.email.files = files;
    },
    WriteEmailBtn() {
      this.writeEmailSection = true;
      this.warningSection = false;
      this.emailPreviewSection = false;
    },
    previewEmailbtn() {
      this.writeEmailSection = false;
      this.warningSection = false;
      this.emailPreviewSection = true;
    },
    GoBack() {
      this.writeEmailSection = true;
      this.warningSection = false;
      this.emailPreviewSection = false;
    },
    close() {
      this.writeEmailSection = false;
      this.warningSection = true;
      this.$emit("close");
    },
    SendEmailBtn() {
      // this.loading = true;
      this.btnloader=true;
      setTimeout(() => {
        this.$swal.fire({
          icon: "success",
          title: "Email have been sent all Users ",
          showConfirmButton: false,
          timer: 3000,
        });
        this.close();
        this.btnloader=false;
      }, 1500);
    },
  },
};
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>
